import {
	Icon,
	Button,
	IconButton,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Text,
	Portal,
} from '@chakra-ui/react'
import React from 'react'
import { FaRegCheckCircle, FaRegCircle } from 'react-icons/fa'
import { MdCheckBox, MdCheckBoxOutlineBlank, MdSort } from 'react-icons/md'
import {
	eventLabelTrack,
	sectionDetailedTrack,
	GA_CATEGORY_DASHBOARD,
} from './../../containers/repository/repo.utils'

const CustomMenu = ({
	optionList,
	onSelect,
	icon,
	selected,
	isCheckBox = false,
	buttonText = '',
	name,
	isFilter,
	closeOnSelect = true,
	...iconProps
}) => {
	const isCheck = data => {
		if (!!isCheckBox) {
			return !!selected?.find(i => i.value === data.value)
		} else {
			return data.value === selected?.value
		}
	}
	return (
		<Menu
			zIndex={100}
			id={name ? `${name}-actions` : 'actions'}
			closeOnSelect={closeOnSelect}
		>
			{buttonText.length > 0 ? (
				<MenuButton
					as={Button}
					rightIcon={icon ? <Icon as={icon} w={6} h={6} /> : null}
					fontSize='0.75rem'
					fontWeight='500'
					lineHeight='1rem'
					bg='white'
					border='1px solid var(--chakra-colors-brand-700)'
					borderRadius='17px'
					{...iconProps}
				>
					{buttonText}
				</MenuButton>
			) : (
				<MenuButton
					as={IconButton}
					bg={selected?.value ? 'secondary' : 'white'}
					_focus={{
						bg: 'secondary',
					}}
					_hover={{
						bg: 'secondary',
					}}
					border='none'
					borderRadius='md'
					boxShadow='md'
					aria-label='Sort'
					size='md'
					icon={<Icon as={icon || MdSort} w={6} h={6} />}
					variant='outline'
					{...iconProps}
				/>
			)}
			{optionList && !!optionList.length ? (
				<Portal>
					<MenuList
						zIndex='1500'
						overflowY='auto'
						maxHeight='50vh'
						boxShadow='0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1);'
						borderRadius='10px'
					>
						{(optionList || []).map((item, i) => {
							if (!!item.isMenu) {
								if (item.hasOwnProperty('disabled') && !!item.disabled) {
									return (
										<MenuItem
											key={Math.random() * Date.now()}
											size='sm'
											py={1}
											icon={item.icon || null}
											disabled={true}
											opacity={0.4}
											{...item.optionListProps}
										>
											<Text fontSize='14px'>{item.label}</Text>
										</MenuItem>
									)
								}
								return (
									<MenuItem
										key={Math.random() * Date.now()}
										size='sm'
										py={1}
										icon={item.icon || null}
										onClick={e => {
											eventLabelTrack({
												categoryId: 0,
												actionId: 2,
												label: `MenuItem ${item.label}`,
											})
											item.onClick(e)
										}}
										{...item.optionListProps}
									>
										<Text fontSize='14px'>{item.label}</Text>
									</MenuItem>
								)
							} else {
								return (
									<MenuItem
										key={item.value}
										size='sm'
										py={1}
										icon={
											!!isCheck(item) ? (
												<Icon
													as={isCheckBox ? MdCheckBox : FaRegCheckCircle}
													w={5}
													h={5}
													border='brand.900'
													color='brand.900'
												/>
											) : (
												<Icon
													as={isCheckBox ? MdCheckBoxOutlineBlank : FaRegCircle}
													w={5}
													h={5}
													color='brand.900'
												/>
											)
										}
										onClick={() => {
											sectionDetailedTrack({
												category: GA_CATEGORY_DASHBOARD,
												action: 'DrillDownTable',
												label: 'Select Menu Item',
											})
											onSelect(item, isCheck(item))
										}}
									>
										<Text fontSize='14px'>{item.label}</Text>
									</MenuItem>
								)
							}
						})}
					</MenuList>
				</Portal>
			) : null}
		</Menu>
	)
}

export default CustomMenu
